<template>
  <div class="app-cfg-tab-val">
    <!-- ({{ cpntCluPcc }}) -->
    <!-- ({{ inputsLimpar }}) -->
    <table>
      <tr class="titulo">
        <td colspan="4">
          Valores licença de uso mensal
        </td>
      </tr>
      <tr class="titulo">
        <td class='nome'>
          Tipo
        </td>
        <td class='qtde'>
          Qtde
        </td>
        <td class='valor_uni'>
          Valor Uni.
        </td>
        <td class='valor_tot'>
          Valor Total
        </td>
      </tr>
      <tr v-if="cpntValorLicencaUso !== ''">
        <td class='nome'>
          {{ cpntTituloValorMensal }}
        </td>
        <td class='qtde'>
          ---
        </td>
        <td class='valor_uni'>
          ---
        </td>
        <td class='valor_tot'>
          R$ {{ valorLicencaUso.formatado }}
        </td>
      </tr>
      <tr v-if="desconto.valor > 0">
        <td class='nome'>
          Desconto
        </td>
        <td class='qtde'>
          ---
        </td>
        <td class='valor_uni'>
          ---
        </td>
        <td class='valor_tot'>
          - R$ {{ desconto.formatado }}
        </td>
      </tr>

      <template v-if="([ '', null, undefined, '0' ].indexOf(cpntValorTestando) === -1 || $store.state.token.usuario === 'SuporteRF') && [ 'l', 'lv' ].indexOf(cpntContratoCLU) !== -1">
        <!-- <tr>
          <td colspan="4" class="divisao">
            &nbsp;
          </td>
        </tr> -->

        <tr class="titulo">
          <td colspan="4">
            Em teste
          </td>
        </tr>
      </template>

      <tr v-if="[ '', null, undefined, '0' ].indexOf(cpntValorTestando) === -1">
        <td class='nome'>
          Valor
        </td>
        <td class='qtde'>
          ---
        </td>
        <td class='valor_uni'>
          ---
        </td>
        <td class='valor_tot'>
          R$ {{ valorTestando.formatado }}
        </td>
      </tr>
      <tr v-if="[ '', null, undefined ].indexOf(cpntValorTestando) !== -1">
        <td class='nome'>
          Usuário adicional
        </td>
        <td class='qtde'>
          {{ qtdeUsuarios.formatado }}
        </td>
        <td class='valor_uni'>
          <template v-if="(cpntOnchangeValue !== null && $store.state.token.usuario === 'SuporteRF')">
            <App-Input
            :cpntStatus="''"
            :cpntNome="''"
            :cpntMask="'valorMoeda'"
            :cpntDisabled="inputsLimpar.indexOf('val_usu') !== -1"
            :cpntValue="inputsLimpar.indexOf('val_usu') !== -1 ? '' : valorUsuarios.valor"
  
            :cpntOnChange="(value) => { appConfigTabTotaisOnChange(value, 'valorUsuarios') }"
            ></App-Input>
            <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_tab_val_usu'" value="val_usu" v-model="inputsLimpar" @change="() => { appConfigTabTotaisOnChange(null, 'val_usu') }">
            <label :for="'ck_cfg_pac_tab_val_usu'" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
          </template>
          <template v-else>
            R$ {{ valorUsuarios.formatado }}
          </template>
          <!-- R$ {{ valorUsuarios.formatado }} -->
        </td>
        <td class='valor_tot'>
          R$ {{ totalUsuarios.formatado }}
        </td>
      </tr>
      <tr v-if="cpntValorContadorPlus !== '' && (cpntCluPcc.indexOf(36) !== -1 || cpntCluPcc.indexOf('36') !== -1)">
        <td class='nome'>
          CNPJ Adicional
        </td>
        <td class='qtde'>
          {{ qtdeContadorPlus.formatado }}
        </td>
        <td class='valor_uni'>
          <template v-if="(cpntOnchangeValue !== null && $store.state.token.usuario === 'SuporteRF')">
            <App-Input
            :cpntStatus="''"
            :cpntNome="''"
            :cpntMask="'valorMoeda'"
            :cpntValue="inputsLimpar.indexOf('36') !== -1 ? '' : valorContadorPlus.valor"
            :cpntDisabled="inputsLimpar.indexOf('36') !== -1"
  
            :cpntOnChange="(value) => { appConfigTabTotaisOnChange(value, 'valorContadorPlus') }"
            ></App-Input>
            <input type="checkbox" class="app-checkbox" id="ck_cfg_pac_tab_36" value="36" v-model="inputsLimpar" @change="() => { appConfigTabTotaisOnChange(null, '36') }">
            <label for="ck_cfg_pac_tab_36" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
          </template>
          <template v-else>
            R$ {{ valorContadorPlus.formatado }}
          </template>
        </td>
        <td class='valor_tot'>
          R$ {{ totalContadorPlus.formatado }}
        </td>
      </tr>
      <tr v-if="cpntValorArmArquivos !== '' && (cpntCluPcc.indexOf(30) !== -1 || cpntCluPcc.indexOf('30') !== -1)">
        <td class='nome'>
          Arm. Arquivo / GB
        </td>
        <td class='qtde'>
          {{ qtdeArmArquivos.formatado }}
        </td>
        <td class='valor_uni'>
          R$ {{ valorArmArquivos.formatado }}
        </td>
        <td class='valor_tot'>
          R$ {{ totalArmArquivos.formatado }}
        </td>
      </tr>
      <tr v-if="cpntValorSincronismo !== '' && (cpntCluPcc.indexOf(37) !== -1 || cpntCluPcc.indexOf('37') !== -1)">
        <td class='nome'>
          CLU Sincronizada
        </td>
        <td class='qtde'>
          {{ qtdeSincronismo.formatado }}
        </td>
        <td class='valor_uni'>
          <template v-if="(cpntOnchangeValue !== null && $store.state.token.usuario === 'SuporteRF')">
            <App-Input
            :cpntStatus="''"
            :cpntNome="''"
            :cpntMask="'valorMoeda'"
            :cpntValue="inputsLimpar.indexOf('37') !== -1 ? '' : valorSincronismo.valor"
            :cpntDisabled="inputsLimpar.indexOf('37') !== -1"
  
            :cpntOnChange="(value) => { appConfigTabTotaisOnChange(value, 'valorSincronismo') }"
            ></App-Input>
            <input type="checkbox" class="app-checkbox" :id="'ck_cfg_pac_tab_37'" value="37" v-model="inputsLimpar">
            <label :for="'ck_cfg_pac_tab_37'" :title="'Marque o checkbox caso deseje reinicializar o valor.'"></label>
          </template>
          <template v-else>
            R$ {{ valorSincronismo.formatado }}
          </template>
        </td>
        <td class='valor_tot'>
          R$ {{ totalSincronismo.formatado }}
        </td>
      </tr>
      <template v-for="pac in cpntBilhetagem">
        <tr v-if="(cpntCluPcc.indexOf(Number(pac.pac_id)) !== -1 || cpntCluPcc.indexOf(pac.pac_id.toString()) !== -1)" :key="'tr-' + pac.pac_id">
          <td class='nome'>
            {{ pac.pac_nome }} /evento<span v-if="[ '', null, undefined ].indexOf(pac.lu_incluso) === -1 && Number(pac.lu_incluso) > 0"> (incluso {{ pac.lu_incluso }})</span>
          </td>
          <td class='qtde'>
            X
          </td>
          <td class='valor_uni'>
            R$ {{ $store.state.FUN_MASK_VALOR('valorMoeda', pac.bilhetagem_valor) }}
          </td>
          <td class='valor_tot'>
            ---
          </td>
        </tr>
      </template>
      <tr v-if="descontoTestando.valor > 0 || (cpntOnchangeValue !== null && $store.state.token.usuario === 'SuporteRF')">
        <td class='nome'>
          Desconto
        </td>
        <td class='qtde'>
          ---
        </td>
        <td class='valor_uni'>
          ---
        </td>
        <td class='valor_tot'>
          <template v-if="(cpntOnchangeValue !== null && $store.state.token.usuario === 'SuporteRF')">
            <App-Input
            :cpntStatus="''"
            :cpntNome="''"
            :cpntMask="'valorMoeda'"
            :cpntValue="descontoTestando.valor"
  
            :cpntOnChange="(value) => { appConfigTabTotaisOnChange(value, 'descontoTestando') }"
            ></App-Input>
          </template>
          <template v-else>
            - R$ {{ descontoTestando.formatado }}
          </template>
        </td>
      </tr>
      <tr>
        <td colspan="3" class="total_nome">
          <b>Total mensal </b>
          <template v-if="[ '', null, undefined, '0' ].indexOf(cpntValorTestando) === -1">
            <b>+ testando: </b>            
          </template>
          <template v-else>
          :
          </template>
        </td>
        <td class="total_valor">
          R$ {{ total.formatado }}
        </td>
      </tr>

      <template v-if="totalTaxaInscricao.valor > 0">
      <!-- <template v-if="[ '', null, undefined ].indexOf(cpntValorTestando) !== -1"> -->
        <tr>
          <td colspan="4" class="divisao">
            &nbsp;
          </td>
        </tr>
  
        <tr class="titulo">
          <td colspan="4">
            Taxas e valores adicionais
          </td>
        </tr>
  
        <tr>
          <td class='nome' colspan="3">
            Taxa Inscrição
          </td>
          <td class='valor_tot'>
            R$ {{ totalTaxaInscricao.formatado }}
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<style scoped>
  .app-cfg-tab-val {
    width: 100%;
    max-width: 480px;
  }
    .app-cfg-tab-val > table {
      width: 100%;
    }
      .app-cfg-tab-val > table > tr.titulo > td {
        font-weight: bold;
        background: #e9e9e9;
        text-align: center !important;
      }
      .app-cfg-tab-val > table > tr > td {
        border: 1px solid #ccc;
        padding: 3px 5px;
      }
      .app-cfg-tab-val > table > tr > td.nome {
        width: calc(100% - 270px);
        text-align: left;
      }
      .app-cfg-tab-val > table > tr > td.qtde {
        width: 90px;
        max-width: 90px;
        text-align: center;
      }
      .app-cfg-tab-val > table > tr > td.valor_uni {
        width: 93px;
        max-width: 93px;
        text-align: center;
      }
      .app-cfg-tab-val > table > tr > td.valor_tot {
        width: 90px;
        max-width: 90px;
        text-align: right;
      }
      .app-cfg-tab-val > table > tr > td.divisao,
      .app-cfg-tab-val > table > tr > td.total_nome {
        text-align: right;
        border: none !important;
      }
      .app-cfg-tab-val > table > tr > td.total_valor {
        text-align: right;
        font-weight: bold;
      }

      .app-cfg-tab-val > table > tr > td.valor_uni > .cpnt-app-input {
        width: calc(100% - 26px);
        vertical-align: -1px !important;
      }
</style>

<script>
  export default {
    props: {
      cpntCluPcc: {
        required: false,
        type: Array,
        default: function () {
          return this.$store.state.token.clu_pcc
        }
      },
      cpntTituloValorMensal: {
        required: false,
        type: String,
        default: function () {
          return 'Licença de uso'
        }
      },
      cpntContratoCLU: {
        required: false,
        type: String,
        default: function () {
          return this.$store.state.token.clu_con
        }
      },
      cpntBilhetagem: {
        required: false,
        type: Array,
        default: function () {
          return []
        }
      },
      cpntValorLicencaUso: {
        required: false
      },

      cpntQtdeUsuarios: {
        required: false
      },
      cpntValorUsuarios: {
        required: false
      },

      cpntQtdeContadorPlus: {
        required: false
      },
      cpntValorContadorPlus: {
        required: false
      },

      cpntQtdeArmArquivos: {
        required: false
      },
      cpntValorArmArquivos: {
        required: false
      },

      cpntQtdeSincronismo: {
        required: false
      },
      cpntValorSincronismo: {
        required: false
      },

      cpntValorDesconto: {
        required: false
      },
      cpntValorDescontoTestando: {
        required: false
      },
      cpntTaxaInscricao: {
        required: false
      },

      cpntValorTestando: {
        required: false
      },
      cpntValorTotal: {
        required: false
      },

      cpntOnchangeValue: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    data: function () {
      return {
        inputsLimpar: [],
        iniciando: true,
        valorLicencaUso:     { valor: 0, formatado: '0,00' },
        qtdeUsuarios:        { valor: 0, formatado: '0,00' },
        valorUsuarios:       { valor: 0, formatado: '0,00' },
        totalUsuarios:       { valor: 0, formatado: '0,00' },
        qtdeContadorPlus:    { valor: 0, formatado: '0,00' },
        valorContadorPlus:   { valor: 0, formatado: '0,00' },
        totalContadorPlus:   { valor: 0, formatado: '0,00' },
        qtdeArmArquivos:     { valor: 0, formatado: '0,00' },
        valorArmArquivos:    { valor: 0, formatado: '0,00' },
        totalArmArquivos:    { valor: 0, formatado: '0,00' },
        qtdeSincronismo:     { valor: 0, formatado: '0,00' },
        valorSincronismo:    { valor: 0, formatado: '0,00' },
        totalSincronismo:    { valor: 0, formatado: '0,00' },
        desconto:            { valor: 0, formatado: '0,00' },
        descontoTestando:    { valor: 0, formatado: '0,00' },
        total:               { valor: 0, formatado: '0,00' },
        totalTaxaInscricao:  { valor: 0, formatado: '0,00' },
        valorTestando:       { valor: 0, formatado: '0,00' }
      }
    },
    mounted: function () {
      this.appConfigTabTotaisIniciar()
    },
    methods: {
      appConfigTabTotaisIniciar: function () {
        // VERIFICA O STATUS QUE DEVE INICIAR
        this.iniciando = [ '', null, undefined ].indexOf(this.cpntValorTestando) === -1 ? false : true

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisLicencaUso()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisQtdeUsuarios()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisValorUsuarios()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisCalcularValorTotalUsuarios()
 
        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisQtdeContadorPlus()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisValorContadorPlus()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisCalcularValorTotalContadorPlus()
 
        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisQtdeArmArquivos()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisValorArmArquivos()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisCalcularValorTotalArmArquivos()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisQtdeSincronismo()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisValorSincronismo()
        
        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisCalcularValorTotalSincronismo()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisDesconto()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisDescontoTestando()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabValorTestando()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalMensal()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalFatura()

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTaxaInscricao()

        setTimeout(() => { this.iniciando = false }, 1000)
      },
      appConfigTabTotaisTotalFatura: function (valor = this.cpntValorTotal) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.total.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.total.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
        }
      },
      appConfigTabTotaisLicencaUso: function (valor = this.cpntValorLicencaUso) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorLicencaUso.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorLicencaUso.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisTotalMensal()
        }
      },
      appConfigTabTotaisQtdeUsuarios: function (valor = this.cpntQtdeUsuarios) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.qtdeUsuarios.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.qtdeUsuarios.formatado = valor
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalUsuarios()
        }
      },
      appConfigTabTotaisValorUsuarios: function (valor = this.cpntValorUsuarios) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorUsuarios.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorUsuarios.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalUsuarios()
        }
      },
      appConfigTabTotaisCalcularValorTotalUsuarios: function () {
        // INICIA O VALOR
        var valor = (this.qtdeUsuarios.valor * this.valorUsuarios.valor)

        // SETA O VALOR RECEBIDO
        this.totalUsuarios.valor = Number(valor)

        // SETA O VALOR ATUALIZADO
        this.totalUsuarios.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalMensal()
      },
      appConfigTabTotaisQtdeContadorPlus: function (valor = this.cpntQtdeContadorPlus) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.qtdeContadorPlus.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.qtdeContadorPlus.formatado = valor
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalContadorPlus()
        }
      },
      appConfigTabTotaisValorContadorPlus: function (valor = this.cpntValorContadorPlus) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorContadorPlus.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorContadorPlus.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalContadorPlus()
        }
      },
      appConfigTabTotaisCalcularValorTotalContadorPlus: function () {
        // INICIA O VALOR
        var valor = (this.qtdeContadorPlus.valor * this.valorContadorPlus.valor)

        // SETA O VALOR RECEBIDO
        this.totalContadorPlus.valor = Number(valor)

        // SETA O VALOR ATUALIZADO
        this.totalContadorPlus.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalMensal()
      },
      appConfigTabTotaisQtdeArmArquivos: function (valor = this.cpntQtdeArmArquivos) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.qtdeArmArquivos.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.qtdeArmArquivos.formatado = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalArmArquivos()
        }
      },
      appConfigTabTotaisValorArmArquivos: function (valor = this.cpntValorArmArquivos) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorArmArquivos.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorArmArquivos.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalArmArquivos()
        }
      },
      appConfigTabTotaisCalcularValorTotalArmArquivos: function () {
        // INICIA O VALOR
        var valor = (Number((this.qtdeArmArquivos.valor * (this.valorArmArquivos.valor / 100)).toFixed(2)) * 100).toString()

        // SETA O VALOR RECEBIDO
        this.totalArmArquivos.valor = Number(valor)

        // SETA O VALOR ATUALIZADO
        this.totalArmArquivos.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalMensal()
      },
      appConfigTabTotaisQtdeSincronismo: function (valor = this.cpntQtdeSincronismo) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.qtdeSincronismo.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.qtdeSincronismo.formatado = valor
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalSincronismo()
        }
      },
      appConfigTabTotaisValorSincronismo: function (valor = this.cpntValorSincronismo) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorSincronismo.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorSincronismo.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisCalcularValorTotalSincronismo()
        }
      },
      appConfigTabTotaisCalcularValorTotalSincronismo: function () {
        // INICIA O VALOR
        var valor = (this.qtdeSincronismo.valor * this.valorSincronismo.valor)

        // SETA O VALOR RECEBIDO
        this.totalSincronismo.valor = Number(valor)

        // SETA O VALOR ATUALIZADO
        this.totalSincronismo.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())

        // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
        this.appConfigTabTotaisTotalMensal()
      },
      appConfigTabTotaisDesconto: function (valor = this.cpntValorDesconto) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.desconto.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.desconto.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisTotalMensal()
        }
      },
      appConfigTabTotaisDescontoTestando: function (valor = this.cpntValorDescontoTestando) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.descontoTestando.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.descontoTestando.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisTotalMensal()
        }
      },
      appConfigTabValorTestando: function (valor = this.cpntValorTestando) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.valorTestando.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.valorTestando.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
  
          // CHAMA A FUNÇÃO PARA CARREGAR OS VALORES
          this.appConfigTabTotaisTotalMensal()
        }
      },
      appConfigTabTotaisTaxaInscricao: function (valor = this.cpntTaxaInscricao) {
        if ([ '', null, undefined ].indexOf(valor) === -1) {
          // SETA O VALOR RECEBIDO
          this.totalTaxaInscricao.valor = Number(valor)
  
          // SETA O VALOR ATUALIZADO
          this.totalTaxaInscricao.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
        }
      },
      appConfigTabTotaisTotalMensal: function () {
        if (this.iniciando === false) {
          // VERIFICA SE TEM LICENÇA VALOR LICENÇA DE USO
          var valor = this.valorLicencaUso.valor
          
          // SOMA O VALOR TOTAL DOS USUARIOS
          valor += this.totalUsuarios.valor
          
          // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
          if (this.cpntCluPcc.indexOf(36) !== -1 || this.cpntCluPcc.indexOf('36') !== -1) {
            valor += this.totalContadorPlus.valor
          }
          
          // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
          if (this.cpntCluPcc.indexOf(30) !== -1 || this.cpntCluPcc.indexOf('30') !== -1) {
            valor += this.totalArmArquivos.valor
          }
          
          // // SOMA O VALOR TOTAL DOS CNPJS CONTADOR PLUS
          // if (this.cpntCluPcc.indexOf(37) !== -1 || this.cpntCluPcc.indexOf('37') !== -1) {
          //   valor += this.totalSincronismo.valor
          // }
          
          // DESCONTA O VALOR DO DESCONTO
          valor -= this.desconto.valor
          
          // DESCONTA O VALOR DO DESCONTO
          valor -= this.descontoTestando.valor
  
          // VERIFICA SE TEM O VALOR TESTANDO
          if (this.valorTestando.valor > 0) {
            valor += this.valorTestando.valor
          }
  
          // SETA O VALOR RECEBIDO
          this.total.valor = Number(valor)
  
          // RETORNA O VALOR CALCULADO E FORMATADO
          this.total.formatado = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor.toString())
        }
      },
      appConfigTabTotaisOnChange: function (value, campo) {
        var valor = null

        switch (campo) {
          case 'valorUsuarios':
            this.cpntOnchangeValue(value, 'valor_ua')
            break

          case 'descontoTestando':
            this.cpntOnchangeValue(value, 'descontoTestando')
            break

          case 'valorSincronismo':
            this.cpntOnchangeValue(value, 'valor_sin_clu_adicional')
            break

          case 'valorContadorPlus':
            this.cpntOnchangeValue(value, 'valor_cnpj_adicional')
            break

          case 'total':
            this.cpntOnchangeValue(value, 'valor_cnpj_adicional')
            break

          case 'val_usu':
            // PEGA O VALOR PARA PREENCHER NO CAMPO
            valor = this.inputsLimpar.indexOf(campo) !== -1 ? null : this.valorUsuarios.valor.toString()
            
            // SETA O VALOR PARA REINICIAR O PROCESSO
            this.cpntOnchangeValue(valor, 'valor_ua')
            break

          case '36':
            // PEGA O VALOR PARA PREENCHER NO CAMPO
            valor = this.inputsLimpar.indexOf(campo) !== -1 ? null : this.valorUsuarios.valor.toString()
            
            // SETA O VALOR PARA REINICIAR O PROCESSO
            this.cpntOnchangeValue(valor, 'valor_cnpj_adicional')
            break
        }
      }
    },
    watch: {
      cpntValorLicencaUso: function () {
        this.appConfigTabTotaisLicencaUso()
      },

      cpntQtdeUsuarios: function () {
        this.appConfigTabTotaisQtdeUsuarios()
      },
      cpntValorUsuarios: function () {
        this.appConfigTabTotaisValorUsuarios()
      },

      cpntQtdeContadorPlus: function () {
        this.appConfigTabTotaisQtdeContadorPlus()
      },
      cpntValorContadorPlus: function () {
        this.appConfigTabTotaisValorContadorPlus()
      },

      cpntQtdeArmArquivos: function () {
        this.appConfigTabTotaisQtdeArmArquivos()
      },
      cpntValorArmArquivos: function () {
        this.appConfigTabTotaisValorArmArquivos()
      },

      cpntQtdeSincronismo: function () {
        this.appConfigTabTotaisQtdeSincronismo()
      },
      cpntValorSincronismo: function () {
        this.appConfigTabTotaisValorSincronismo()
      },

      cpntValorTestando: function () {
        this.appConfigTabValorTestando()
      },

      cpntValorDesconto: function () {
        this.appConfigTabTotaisDesconto()
      },
      cpntValorDescontoTestando: function () {
        this.appConfigTabTotaisDescontoTestando()
      },
      cpntTaxaInscricao: function () {
        this.appConfigTabTotaisTaxaInscricao()
      },
      cpntCluPcc: function () {
        this.appConfigTabTotaisTotalMensal()
      }
    }
  }
</script>
